module.exports = __webpack_public_path__ + "static/media/linkedInIcon.090212fc.svg";